<script>
import '~/assets/css/layer.css'
</script>
<template>
    <div class="row">
        <div class="col">
            <div class="layer-sprite">
                <div class="layer-hitbox"></div>
                <div class="layer-collision"></div>
                <CharacterMooDeng pose="run" />
            </div>
        </div>
        <div class="col">
            <pre>
Sprite      0,0      128,128
Collision   21,32    80,60
Hitbox      25,40    70,40
            </pre>
        </div>
    </div>
</template>